import { getCache } from 'Apollo';
import { ShowroomFilterGroupsInfoFragment } from 'generated/graphql';

import { SHOWROOM_FILTER_GROUP_INFO } from './queries';

const cache = getCache();

export const getShowroomFiltersInfo = (ids: string[]): ShowroomFilterGroupsInfoFragment[] =>
	ids.map(groupId =>
		cache.readFragment({
			id: cache.identify({ __typename: 'ShowroomFilter', id: groupId }),
			fragment: SHOWROOM_FILTER_GROUP_INFO
		})
	);
